<template>
    <div class="card bg-hover-light-light">
        <div class="card-header">
            <div class="d-flex flex-md-row flex-column gap-5">
                <div>
                    <Productable :productable="bundle"/>
                </div>
                <div class="flex-grow-1 d-flex flex-row justify-content-end">
                    <div class="d-flex flex-column justify-content-center">
                        <div class="btn-group">
                            <button v-if="Permission.DELETE_SUBSCRIPTION_BUNDLES"
                                    class="btn btn-outline-secondary btn-hover-danger"
                                    :class="{'pointer-events-none opacity-50': true}"
                                    @click="deleteBundle"
                            >
                                <i class="fas fa-trash mr-1"/>
                                {{ __('actions.delete') }}
                            </button>
                            <Link v-if="Permission.EDIT_SUBSCRIPTION_BUNDLES"
                                  as="button"
                                  class="btn btn-outline-secondary btn-hover-primary"
                                  :href="$route('subscriptions.bundles.edit', bundle.id)"
                                  :class="{'pointer-events-none opacity-50': true}"
                            >
                                <i class="fas fa-edit mr-1"/>
                                {{ __('actions.edit_thing', {thing: __('subscriptions.bundle')}) }}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-body">
            <div class="d-flex flex-md-row flex-column justify-content-between gap-10">
                <div class="features">
                    <div class="font-weight-bold text-xl mb-1">
                        {{ __('subscriptions.features') }}
                    </div>
                    <div class="d-flex flex-column">
                        <div v-for="feature in bundle.features">
                            <Link as="a" :href="$route('subscriptions.features.show', feature.id)">
                                {{ getTranslation(feature.lang.name) || 'Unknown product' }}
                            </Link>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="font-weight-bold text-xl mb-1">
                        {{ __('general.subscriptions') }}
                    </div>
                    <div>
                        <Link as="a" :href="$route('subscriptions', {bundle: bundle.id})">
                            {{ bundle.subscriptions_count }} {{ __('general.active') }}
                        </Link>
                    </div>
                </div>
                <div>
                    <!--                    <div class="font-weight-bold text-right text-xl mb-1">-->
                    <!--                        {{ __('subscriptions.price_groups') }}-->
                    <!--                    </div>-->
                    <div class="d-flex flex-md-row flex-column justify-content-end gap-1">
                        <PricingGroup v-for="(pricings, pricingGroupName) in bundle.pricing_groups"
                                      :key="pricingGroupName"
                                      :name="pricingGroupName"
                                      :pricings="pricings"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer py-4 font-weight-light font-size-sm text-muted">
            <div>{{ __('general.created') }}: {{ $localDate(bundle.created_at) }}</div>
        </div>
    </div>
</template>

<script>
import { Link } from '@inertiajs/vue2';
import {PermissionsMixin} from "@js/permissions";
import Productable from "@components/Subscriptions/Productable";
import PricingGroup from "@components/Subscriptions/Pricing/PricingGroup";
import helperMethods from '@mixins/helperMethods'

export default {
    components: {Productable, PricingGroup, Link},

    mixins: [PermissionsMixin, helperMethods],

    props: {
        bundle: Object
    },

    methods: {
        deleteBundle() {
            let url = this.$route('subscriptions.bundles.delete', this.bundle.id);
            //TODO: confirm & delete
        }
    }
}
</script>

<style>
.features {
    max-width: 360px;
}
</style>
